import { Sparkles } from 'lucide-react';
import { defineMessages } from '../../i18n/define';
import { useT } from '../../i18n/hooks';

const m = defineMessages({
  label: { id: 'board.askAi.label', defaultMessage: 'Спросить ИИ с этим контекстом', description: 'Кнопка на странице: открыть панель ИИ-помощника с контекстом экрана (все роли)' },
});

/**
 * «Спросить ИИ с этим контекстом».
 *
 * Панель ИИ (`agent/AgentPanel.tsx`) принадлежит другому потоку и не имеет
 * внешнего API открытия: её состояние `open` внутреннее. Единственная
 * публичная точка входа — её плавающая кнопка, поэтому кнопка страницы нажимает
 * именно её. Контекст (адрес, дата среза, видимый текст экрана) панель читает
 * сама в момент отправки (`useAgentSnapshot`), так что страница ничего не
 * передаёт — ответ ИИ видит ровно тот ответ, что открыт у человека.
 * Если панели на странице нет (ИИ-слой выключен), кнопка не рисуется.
 */
const FAB = 'button.agent-fab';

export function openAgentPanel(root: ParentNode = document): boolean {
  const fab = root.querySelector<HTMLButtonElement>(FAB);
  if (!fab) return false;
  fab.click();
  return true;
}

export function AskAiButton({ label }: { label?: string }) {
  const t = useT();
  return (
    <button
      type="button"
      className="astra-button"
      data-guide="ask-ai"
      onClick={() => openAgentPanel()}
    >
      <Sparkles size={15} />
      {label ?? t(m.label)}
    </button>
  );
}
